import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { blue_pilu } from '../../../helpers/utils';

export default function Title(props) {
	return (
		<Typography
			component='h2'
			variant='h6'
			style={{ color: blue_pilu }}
			gutterBottom
		>
			{props.children}
		</Typography>
	);
}

Title.propTypes = {
	children: PropTypes.node,
};
